<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getImpuesto } from '@/services/configurations/getImpuesto'
import { getHistoricalByImpuesto } from '@/services/historical/getHistoricalByImpuesto'
import { getHistoricalByImpuestoExcel } from '@/services/historical/getHistoricalByImpuestoExcel'

export default {
  name: 'list-tax-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 63,
      vuexnamespace: 'historicalImpuestos',
      headerUrl: 'masters/impuestos/details',
      breadcrumbs: [
        { 
          url: this.role === 3 ? 'configurationssa' : 'configurations', 
          name: i18n.t('configurations.header') 
        },
        { url: 'masters/impuestos', name: i18n.t('impuestos.header') },
        { paths: ['Name'] },
      ],
      ExcelName: `${_.kebabCase(i18n.t('impuestos.entity_name') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  methods: {
    getParamsAux: function (data) {
      return { idImpuesto: this.$route.params.id }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getImpuesto(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByImpuestoExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByImpuesto(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
